import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatComma } from '../utils/utils';

const OIWebTable = ({ styles, selectDate, makeModelRowData }) => {
  const state = useSelector((state) => state.OpenInterestState);
  const appReducer = useSelector((state) => state.appReducer);

  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow style={{ height: '31.5px' }}>
          {appReducer.OIDates.map(
            (row, index) =>
              index !== 0 && (
                <TableCell
                  key={index}
                  style={
                    state.dates.indexOf(row) !== -1
                      ? styles.headercelled
                      : styles.headercell
                  }
                  onClick={() => selectDate(row)}
                >
                  {row !== 'Strike' ? moment(row).format('DD-MMM-YY') : row}
                </TableCell>
              )
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {(state.type === 'calls'
          ? appReducer.OIDataCall 
          : appReducer.OIDataPut
        ).map((row, rowindex) => (
          <TableRow
            key={rowindex}
            style={
              row[0] >= state.fromValue && row[0] <= state.toValue
                ? rowindex % 2 === 0
                  ? styles.normalrow
                  : styles.normalrowlight
                : styles.shaderow
            }
          >
            {row.map(
              (cell, cellindex) =>
                cellindex !== 0 && (
                  <TableCell
                    className="toggleCellsOPEN"
                    key={cellindex}
                    onClick={async () => {
                      makeModelRowData(row, cell, state.dates, cellindex);
                    }}
                    style={
                      (cellindex === 0 ? styles.strikecell : styles.tbcell,
                        state.type === 'calls'
                        ? row[0] >= state.fromValue &&
                        row[0] <= state.toValue &&
                        cell >= state.callsLimit
                        ? styles.tbcellhighlight
                        : styles.tbcell
                        : row[0] >= state.fromValue &&
                        row[0] <= state.toValue &&
                        cell >= state.putsLimit
                        ? styles.tbcellhighlight
                        : styles.tbcell)
                      }
                      >
                    {formatComma(parseFloat(cell))}
                  </TableCell>
                )
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
export default OIWebTable;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/webViewComponents/OITable.jsx